import React from 'react';
// import { useForm } from 'react-hook-form';
import { OnboardingFormStepLayout } from '@features/onboarding/layouts/OnboardingFormStepLayout';
import { useGeneralStore } from 'src/store';

export const WelcomeForm = () => {
  const { siteConfig } = useGeneralStore();

  return (
    <OnboardingFormStepLayout onlyImage={true}>
      <img
        src={siteConfig?.images?.welcome ?? ""}
        alt=""
        className="w-full h-full object-cover object-top"
      />
    </OnboardingFormStepLayout>
  );
};
